<div class="page-container" [class.loading]="isLoading">
    <app-header title="{{ 'employees.onboardingSettings.collectEmployeeBankingInfo' }}" [back]="true"></app-header>
    <div class="ui layout">
        <div class="content">
            <ui-card>
                <ui-banner class="margin-bottom-2" variant="info"
                    ><span>{{ 'employees.onboardingSettings.collectEmployeeBankingInfoNotice' | translate }}</span>
                </ui-banner>
                <div *ngIf="settings?.bankingInformationRequired">
                    <label class="vertical" id="bank-info-required">{{
                        'employees.onboardingSettings.bankingInfoRequiredForAll' | translate
                    }}</label>
                    <mat-radio-group
                        class="vertical"
                        aria-labelledby="bank-info-required"
                        name="bank-info-required"
                        [(ngModel)]="settings.bankingInformationRequired.value"
                        (ngModelChange)="onBankingInfoRadioChange($event)"
                        required
                    >
                        <mat-radio-button [value]="true">{{
                            'employees.onboardingSettings.yesRequired' | translate
                        }}</mat-radio-button>
                        <mat-radio-button [value]="false">{{
                            'employees.onboardingSettings.noOptional' | translate
                        }}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </ui-card>

            <div class="flex buttons justify-end">
                <ui-button type="link" (click)="onCancel()">{{ 'cancel' | translate }}</ui-button>
                <ui-button type="primary" (click)="onSave()">{{ 'save' | translate }}</ui-button>
            </div>
        </div>
    </div>
</div>
